module.exports = __webpack_public_path__ + "img/discord.00854f20.svg";